import MeetingForm from "../MeetingForm.vue";
import { validate } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from "vee-validate/dist/rules";
import {ValidationRuleSchema} from "vee-validate/dist/types/types";
import {DateTime} from "luxon";
import i18n from "../../../service/locale/i18";

let rulesExtended = false;

const extendRules = () => {

    extend('required', required);

    extend("isTimeCorrect", ({
        params: ["toTime"],
        validate: (value, { toTime }: any) => {
            if (value && toTime) {
                return value < toTime;// Date.parse(`01/01/2000 ${value}`) < Date.parse(`01/01/2000 ${toTime}`);
            }
            return true;
        },
        message: i18n.t("errors.isTimeCorrect").toString()
    } as ValidationRuleSchema));

    extend("isTimeNotPast", ({
        validate: (value: any) => {
            if (value) {
                return value >= DateTime.local();
            }
            return true;
        },
        message: i18n.t("errors.isTimeNotPast").toString()
    } as ValidationRuleSchema));

    extend("isDateNotPast", ({
        validate: (value: any) => {
            if (value) {
                const now = DateTime.local().startOf('day'),
                    date = DateTime.fromISO(value).startOf('day');
                return date >= now;
            }
            return true;
        },
        message: i18n.t("errors.isDateNotPast").toString()
    } as ValidationRuleSchema));

    rulesExtended = true;
}

const doValidation = async (component: MeetingForm) => {

    if(!rulesExtended) {
        extendRules();
    }

    const errors: {[key: string]: string} = {};
    const titleValidate = await validate(component.meeting.title, 'required', {customMessages: {
            required: i18n.t("errors.titleValidate").toString()
        }});
    if (!titleValidate.valid) {
        errors['title'] = titleValidate.errors.join('<br>');
    }

    const dateValidate = await validate(component.date, 'required|isDateNotPast', {customMessages: {
            required: i18n.t("errors.dateValidate").toString()
        }});
    if (!dateValidate.valid) {
        errors['date'] = dateValidate.errors.join('<br>');
    }

    const toValidate = await validate(component.toTime, 'required', {customMessages: {
            required: i18n.t("errors.toValidate").toString()
        }});
    if (!toValidate.valid) {
        errors['time'] = toValidate.errors.join('<br>');
    }

    const fromValidate = await validate(component.meeting.beginAt, 'required|isTimeCorrect:@toTime|isTimeNotPast', {
        values: {
            toTime: component.meeting.endAt
        },
        customMessages: {
            required: i18n.t("errors.fromValidate").toString()
        }
    });

    if (!fromValidate.valid) {
        errors['time'] = (errors['time'] ? errors['time'] + '<br>' : '') + fromValidate.errors.join('<br>');
    }

    const participantsValidate = await validate(component.meeting.participants.filter(item => item.userId != component.meeting.ownerId), 'required', {customMessages: {
            required: i18n.t("errors.participantsValidate").toString()
        }});
    if (!participantsValidate.valid) {
        errors['participants'] = participantsValidate.errors.join('<br>');
    }
    component.errors = errors;

    return Object.keys(errors).length === 0;
}

export {doValidation}
